<template>
	<div>
		<i class="el-icon-loading" v-if="message._status === 0" />
		<i class="el-icon-warning error" v-if="message._status === 2" @click="handleErrorClick" />
	</div>
</template>

<script>
export default {
	name: "ChatMessageStatus",

	props: {
		message: {
			type: Object,
			require: true,
		},
	},

	data() {
		return {
			//
		};
	},

	methods: {
		async handleErrorClick() {
			const result = await this.$confirm(this.$t("chatMessageStatus.resendThisMessage"), this.$t("chatMessageStatus.hint"), {
				confirmButtonText: this.$t("common.sure"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			});

			if (result) {
				this.$emit("on-error-click", this.message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.error {
	color: #f66b6b;
}
</style>
